import { render } from "./FollowUpForm.vue?vue&type=template&id=a32e2274&scoped=true"
import script from "./FollowUpForm.vue?vue&type=script&lang=js"
export * from "./FollowUpForm.vue?vue&type=script&lang=js"

import "./FollowUpForm.vue?vue&type=style&index=0&id=a32e2274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a32e2274"]])

export default __exports__